import { render, staticRenderFns } from "./DocumentExportModal.vue?vue&type=template&id=64ac48a4&scoped=true&"
import script from "./DocumentExportModal.vue?vue&type=script&lang=ts&"
export * from "./DocumentExportModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ac48a4",
  null
  
)

export default component.exports